import React from "react";
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from "components/CustomButtons/Button.jsx";
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio"
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import TextField from '@material-ui/core/TextField';

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { verifyNumber } from "../../assets/helpers/formHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle
};

class MarketingPlan extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')
    var templateId;
    if (props.templateId) {
      templateId = props.templateId
    }

    this.state = {
      userId: userId,
      templateId: templateId,
      activeStep: 0,
      theQuestion: '',
      questionType: '',
      answerOptions: [],
      questionId: '',
      numSteps: 0,
      questions: '',
      answers: {},
      answersWarning: {},
      planText: [{'line': 'loading...'}],
      generateMarketingPlanButtonDisabled: true
    };

  }
  componentDidMount() {
    this._isMounted = true;
    this.getTemplate()
    this.getPlanText()
  }

  getTemplate() {
    axios.get(`${API_ROOT}/marketing/template/?templateId=`+this.state.templateId, {headers: getApiHeaders()})
      .then(res => this.setTemplate({templateQuestions: res.data}));
  }

  setTemplate(res) {
    if (!res.error) {
      var templateQuestions = res.templateQuestions
      const answers = {}
      answers[templateQuestions[0]['id']] = ''
      this.setState({
        theQuestion: templateQuestions[0]['question'],
        questionType: templateQuestions[0]['type'],
        answerOptions: templateQuestions[0]['options'],
        questionId: templateQuestions[0]['id'],
        numSteps: templateQuestions.length,
        questions: templateQuestions,
        answers: answers
      })
      this.getTemplateAnswers()
    }
  }

  getTemplateAnswers() {
    axios.get(`${API_ROOT}/marketing/templateAnswers/?templateId=`+this.state.templateId+`&userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setTemplateAnswers(res.data));
  }

  setTemplateAnswers(res) {
    if (res.length > 0) {
      const answers = {}
      //set the first answer to empty
      //otherwise we get an error if it is not returned
      answers[this.state.questionId] = ''
      for (var answerKey in res) {
        var answerObject = res[answerKey]
        if (answerObject.type === 'checkbox') {
          answers[answerObject.id] = JSON.parse(answerObject.answer)
        } else {
          answers[answerObject.id] = answerObject.answer
        }

      }
      this.setState({
        answers: answers
      })
    }
  }

  setNextStep(stepDirection) {
    if (this.checkForAnswerWarning()) {
      alert('Please correct your answer before continuing.')
    } else if (this.state.activeStep + 1 === this.state.numSteps && stepDirection === 1) {
      this.onSubmitPlan()
    } else {
      const newActiveStep = this.state.activeStep + stepDirection
      var answers = this.state.answers
      if (answers[this.state.questions[newActiveStep]['id']] === undefined) {
        answers[this.state.questions[newActiveStep]['id']] = ''
      }
      this.setState({
        activeStep: newActiveStep,
        theQuestion: this.state.questions[newActiveStep]['question'],
        questionType: this.state.questions[newActiveStep]['type'],
        answerOptions: this.state.questions[newActiveStep]['options'],
        questionId: this.state.questions[newActiveStep]['id'],
        answers: answers
      })
      if (this.state.generateMarketingPlanButtonDisabled && newActiveStep+1 === this.state.numSteps) {
        this.setState({
          generateMarketingPlanButtonDisabled: false
        })
      }
    }

  }

  checkForAnswerWarning() {
    if (this.state.answersWarning[this.state.questions[this.state.activeStep]['id']] && this.state.answersWarning[this.state.questions[this.state.activeStep]['id']] !== '') {
      return true;
    } else {
      return false
    }
  }

  changeField(event, fieldType, value) {
    var answers = this.state.answers
    if (fieldType === 'checkbox') {
      var currentAnswer = answers[this.state.questionId]
      if (currentAnswer === '') {
        currentAnswer = {}
      }
      //if the value is not already in the answer, put it in
      // otherwise, take it out to uncheck
      if (currentAnswer[value]) {
        currentAnswer[value] = false
      } else {
        currentAnswer[value] = true
      }
      answers[this.state.questionId] = currentAnswer
    } else if (fieldType === 'radio') {
      answers[this.state.questionId] = value
    } else if (fieldType === 'number') {
      var warning;
      if (event.target.value === '' || verifyNumber(event.target.value)) {
        warning = ''
      } else {
        warning = 'Please enter a number in the field.'
      }
      var answersWarning = this.state.answersWarning
      answersWarning[this.state.questionId] = warning
      this.setState({
        answersWarning: answersWarning
      })
      answers[this.state.questionId] = event.target.value
    } else {
      answers[this.state.questionId] = event.target.value
    }
    this.setState({
      answers: answers
    })
  }

  onSubmitPlan() {
    if (this.checkForAnswerWarning()) {
      alert('Please correct your answer before continuing.')
    } else {
      const answers = JSON.stringify(this.state.answers)
      const answerData = {
        answers: answers,
        userId: this.state.userId
      }
      axios.post(`${API_ROOT}/marketing/templateAnswers/`, answerData, { headers: getApiHeaders() })
        .then(res => this.handleSubmitPlan(res));
    }
  }

  handleSubmitPlan(res) {
    this.props.displayPlanOpen()
  }

  getPlanText() {
    axios.get(`${API_ROOT}/marketing/templateDisplay/?templateId=`+this.state.templateId+`&userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setPlanText(res.data));
  }

  setPlanText(planText) {
    var planTextDisplay = []
    var line = {'fontSize': '16px', 'fontColor': '', 'fontWeight': '', 'line': planText.intro}
    planTextDisplay.push(line)

    const allAnswers = planText.answers
    for (var answer in allAnswers) {
      line = {'fontSize': '20px', 'fontColor': '', 'fontWeight': 'bold', 'line': allAnswers[answer].printText}
      planTextDisplay.push(line)
      line = {'fontSize': '16px', 'fontColor': '', 'fontWeight': '', 'line': allAnswers[answer].answer}
      planTextDisplay.push(line)
    }

    line = {'fontSize': '16px', 'fontColor': '', 'fontWeight': '', 'line': planText.closing}
    planTextDisplay.push(line)

    this.setState({
      planText: planTextDisplay
    })
  }

    render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center', height: '100%'}}>
        <GridContainer style={{height: '300px', overflow: 'auto'}}>
          <GridItem xs={12} sm={12}>
            <h4>{this.state.theQuestion}</h4>

            <GridContainer className={classes.answerOptions} style={this.state.questionType === 'text' ? {} : { display: 'none' }}>
              <GridItem xs={12} sm={12}>
                <TextField
                  id={"textField"}
                  multiline={true}
                  onChange={event => this.changeField(event, 'text')}
                  value={this.state.questionType === 'text' ? this.state.answers[this.state.questionId] : ''}
                />
              </GridItem>
            </GridContainer>

            <GridContainer className={classes.answerOptions} style={this.state.questionType === 'number' ? {} : { display: 'none' }}>
              <GridItem xs={12} sm={12}>
                <TextField
                  id={"textField"}
                  multiline={true}
                  onChange={event => this.changeField(event, 'number')}
                  value={this.state.questionType === 'number' ? this.state.answers[this.state.questionId] : ''}
                />{this.state.answersWarning[this.state.questionId]}
              </GridItem>
            </GridContainer>

            <GridContainer className={classes.answerOptions} style={this.state.questionType === 'radio' ? {} : { display: 'none' }}>
              <GridItem xs={12} sm={8}>
                {this.state.answerOptions.map((option, key) =>
                  <div key={key}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={this.state.answers[this.state.questionId] === option.value}
                          onChange={event => this.changeField(event, 'radio', option.value)}
                          value={option.value}
                          name={option.text}
                          aria-label="E"
                          icon={
                            <FiberManualRecord
                              className={classes.radioUnchecked}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecord
                              className={classes.radioChecked}
                            />
                          }
                          classes={{
                            checked: classes.radio,
                            root: classes.radioRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label
                      }}
                      label={option.text}
                    />
                  </div>
                )}
              </GridItem>
            </GridContainer>
            <GridContainer className={classes.answerOptions} style={this.state.questionType === 'checkbox' ? {} : { display: 'none' }}>
              <GridItem xs={12} sm={12} md={12}>
                {this.state.answerOptions.map((option, key) =>
                  <div key={key}>
                    <FormControlLabel
                      control={<Checkbox
                        id={'checkboxItem'}
                        label={'nice job'}
                        onClick={event => this.changeField(event, 'checkbox', option.value)}
                        checkedIcon={<Check className={classes.checkedIcon}/>}
                        icon={<Check className={classes.uncheckedIcon}/>}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                        checked={this.state.answers[this.state.questionId][option.value] === true}
                      />
                      }
                    />
                    {option.text}
                  </div>
                )}
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <MobileStepper
              variant="progress"
              steps={this.state.numSteps}
              position="static"
              activeStep={this.state.activeStep}
              backButton={
                <Button size="sm" color="cirrusBlue" onClick={() => this.setNextStep(-1)} disabled={this.state.activeStep === 0}>
                  <KeyboardArrowLeft />
                  Back
                </Button>
              }
              nextButton={
                <Button size="sm" color="cirrusBlue" onClick={() => this.setNextStep(1)}>
                  {this.state.activeStep + 1 === this.state.numSteps ? 'generate plan' : 'Next' }

                  <KeyboardArrowRight />
                </Button>
              }
            />
          </GridItem>
        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(MarketingPlan);
